import { HttpLoaderFactory } from '../shared/shared.module';
var ɵ0 = HttpLoaderFactory;
var FullMenuModule = /** @class */ (function () {
    function FullMenuModule() {
    }
    return FullMenuModule;
}());
export { FullMenuModule };
export { ɵ0 };
